import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safety-security',
  templateUrl: './safety-security.component.html',
  styleUrls: ['./safety-security.component.scss']
})
export class SafetySecurityComponent implements OnInit {

  campusImages = [
    '/assets/img/campus/1.jpg',
    '/assets/img/campus/2.jpg',
    '/assets/img/campus/6.jpg',
    '/assets/img/campus/10.jpg'
  ];

  securityImages = [
    '/assets/img/quick-links/safety-security/1 (1).jpg',
    '/assets/img/quick-links/safety-security/1 (2).jpg',
    '/assets/img/quick-links/safety-security/1 (3).jpg',
    '/assets/img/quick-links/safety-security/1 (4).jpg',
    '/assets/img/quick-links/safety-security/1 (5).jpg',
    '/assets/img/quick-links/safety-security/1 (6).jpg',
    '/assets/img/quick-links/safety-security/1 (7).jpg',
    '/assets/img/quick-links/safety-security/1 (8).jpg',
    '/assets/img/quick-links/safety-security/1 (9).jpg',
    '/assets/img/quick-links/safety-security/1 (10).jpg',
    '/assets/img/quick-links/safety-security/1 (11).jpg',
    '/assets/img/quick-links/safety-security/1 (12).jpg',
    '/assets/img/quick-links/safety-security/1 (13).jpg',
    '/assets/img/quick-links/safety-security/1 (14).jpg',
    '/assets/img/quick-links/safety-security/1 (15).jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

}
